$(document).ready(function() {
  function ajaxfunction(customerselection, spcustomerselection) {
    $('.b2bUnitId').val(customerselection);
    $('.b2bSpUnitId').val(spcustomerselection);
    $('.ph-customerselection').addClass('ph-disabledbutton ');
    $('#b2b_Customer_Selection_Unit_Form').submit();
  }

  function selectionBoth(popupText, sppopupText, customerselection, spcustomerselection) {
    if (popupText === 'true' && sppopupText === 'true') {
      if (customerselection === '' || spcustomerselection === '') {
        window.scrollTo(0, 0);
        $('.ph-noselectionmessage').show();
      } else {
        ajaxfunction(customerselection, spcustomerselection);
      }
    }
  }

  function selectionRegular(popupText, sppopupText, customerselection, spcustomerselection) {
    if (popupText === 'true' && sppopupText === 'false') {
      if (customerselection === '') {
        window.scrollTo(0, 0);
        $('.ph-noselectionmessage').show();
      } else {
        ajaxfunction(customerselection, spcustomerselection);
      }
    }
  }

  function selectionSpare(popupText, sppopupText, customerselection, spcustomerselection) {
    if (popupText === 'false' && sppopupText === 'true') {
      if (spcustomerselection === '') {
        window.scrollTo(0, 0);
        $('.ph-noselectionmessage').show();
      } else {
        ajaxfunction(customerselection, spcustomerselection);
      }
    }
  }

  $(document).on('click', '.ph-customerselection', function() {
    var customerselection = '',
        spcustomerselection = '',
        popupText = $('.ph-popup').text(),
        sppopupText = $('.ph-sppopup').text();

    $('.ph-customerradio').each(function() {
      if ($(this).is(':checked')) {
        customerselection = $(this).val();
      }
    });
    $('.ph-customerspradio').each(function() {
      if ($(this).is(':checked')) {
        spcustomerselection = $(this).val();
      }
    });
    selectionBoth(popupText, sppopupText, customerselection, spcustomerselection);
    selectionRegular(popupText, sppopupText, customerselection, spcustomerselection);
    selectionSpare(popupText, sppopupText, customerselection, spcustomerselection);
  });

  function bTobunitFormSubmit(formId, inputId, curObj) {
    $(inputId).val($(curObj).val());
    $(formId).submit();
  }

  $('#desk_b2bunit').change(function() {
    bTobunitFormSubmit('#desk_b2b_Customer_Selection_Unit_Form', '.b2bUnitId', this);
  });
  $('#desk_sp_b2bunit').change(function() {
    bTobunitFormSubmit('#desk_b2b_Customer_Selection_Unit_Form', '.b2bSpUnitId', this);
  });
  $('#mob_b2bunit').change(function() {
    bTobunitFormSubmit('#mob_b2b_Customer_Selection_Unit_Form', '#mob_b2b_Customer_Selection_Unit_Form .b2bUnitId', this);
  });
  $('#mob_sp_b2bunit').change(function() {
    bTobunitFormSubmit('#mob_b2b_Customer_Selection_Unit_Form', '#mob_b2b_Customer_Selection_Unit_Form .b2bSpUnitId', this);
  });
  setTimeout(function() {
    $('.desk_sp_b2bunit-selectBox-dropdown-menu').width('80px');
  }, 300);

  $('#b2b_Customer_Selection_Unit_Form').submit(function() {
    $('.ph-loader__default').removeClass('hidden');
  });
});
